import React from "react";
import Select from "react-select";

const CustomSelect = ({ ...rest }) => {
  return (
    <Select
      {...rest}
      classNamePrefix="select"
    />
  );
};

CustomSelect.propTypes = {};

export default CustomSelect;
